import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { ServiceContract } from './ServiceContract.entity';

export class ModifyShadowServiceContractResult<T extends EMode = EMode.entity> {
  /** Alias: id */
  id?: string;
  /** Alias: name */
  name?: string;
  /** Alias: benutzerCode */
  benutzerCode?: number;
  /** Alias: serviceContractCode */
  serviceContractCode?: number;
  /** Alias: insertTime */
  insertTime?: string;
  /** Alias: updateTime */
  updateTime?: string;
  /** Alias: customerCode */
  customerCode?: number;
  /** Alias: projektCode */
  projectCode?: number;
  /** Alias: data */
  data?: ServiceContract<T>;
  /** Alias: createdCodes */
  createdCodes?: number[];

  __typename?: string;
}

const fields: FieldDefinitions<ModifyShadowServiceContractResult> = {
  id: {
    alias: 'id',
  },
  name: {
    alias: 'name',
  },
  benutzerCode: {
    alias: 'benutzerCode',
  },
  serviceContractCode: {
    alias: 'serviceContractCode',
  },
  insertTime: {
    alias: 'insertTime',
  },
  updateTime: {
    alias: 'updateTime',
  },
  customerCode: {
    alias: 'customerCode',
  },
  projectCode: {
    alias: 'projektCode',
  },
  data: {
    alias: 'data',
    entity: Entities.serviceContract,
  },
  createdCodes: {
    alias: 'createdCodes',
  },
  __typename: {
    alias: '__typename',
  },
};

export const modifyShadowServiceContractResultEntityDefinition: EntitiyDefinition<ModifyShadowServiceContractResult> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'ModifyShadowServiceContractResult',
      withPaginationWrapper: false,
      mutations: {
        upsert: {
          mutationName: 'createShadowServiceContract',
          args: [
            { name: 'customerCode', type: 'Int' },
            { name: 'apCode', type: 'Int' },
            { name: 'serviceContractCode', type: 'Int' },
            { name: 'projectCode', type: 'Int' },
            { name: 'name', type: 'String' },
          ],
        },
      },
    },
    fieldDefinitions: fields,
  };
